var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorStroke(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2819 2.42614L2.90577 6.45147L9.64892 9.41845C9.93511 9.54438 10.1637 9.77298 10.2896 10.0592L13.2566 16.8023L17.2819 2.42614ZM17.3055 0.861859C18.2441 0.599038 19.109 1.46396 18.8462 2.4026L14.5128 17.8793C14.1963 19.0094 12.6376 19.1199 12.1649 18.0457L8.95582 10.7523L1.66243 7.54318C0.588194 7.07052 0.698664 5.51177 1.82881 5.19533L17.3055 0.861859Z",
    fill: "#2E4D6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorStroke);
export default __webpack_public_path__ + "static/media/Vector (Stroke).06f1c66fbb3064357f6f5a8f112169ff.svg";
export { ForwardRef as ReactComponent };